import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/smackback/banner.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section
      className="smackback_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={4} xxl={4} className="my-auto">
            <div className="logo_img">
              <StaticImage
                src="../../../images/case-studies/smackback/logo.webp"
                alt="TekRevol Novelcraft"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={79}
                height={88}
              />
            </div>
            <h1 style={{ color: "#fff" }}>
              The Number #1 Message Scheduling App Out There
            </h1>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-lg-1 offset-xl-2 my-auto text-center"
          >
            <div className="smack_img">
              <StaticImage
                src="../../../images/case-studies/smackback/banner_img.webp"
                alt="TekRevol Novelcraft"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={658}
                height={750}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
